export default "__VITE_ASSET__Cn1Metyd__"